export default __webpack_public_path__ + "static/media/account_logo.4c255747.svg";